<template>
  <div class="modal fade" tabindex="-1" :id="id" :data-bs-backdrop="true" aria-labelledby="confirmModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border">
        <div class="modal-header">
          <h2 class="h2 mb-0">{{ title }}</h2>
          <i type="button" class="fas fa-times text-muted" data-bs-dismiss="modal" aria-label="Close"></i>
        </div>
        <div class="modal-body border-0">
          {{ message }}
        </div>
        <div class="modal-footer">
            <button @click="handleAction('cancel')" class="btn btn-outline-dark btn-sm">{{ cancelText }}</button>
            <button @click="handleAction('confirm')" class="btn btn-dark btn-sm">{{ confirmText }}</button>
        </div>
      </div>
    </div>
  </div>
  <button hidden :id="`trigger-${id}-btn`" type="button" data-bs-toggle="modal" :data-bs-target="`#${id}`"></button>
</template>
<script lang="ts" setup>
import { EModal } from '@/enums';
import useModals from './useModals';
import { ConfirmModalResponse } from './modals.types';

const id = EModal.confirm
const { toggleModal } = useModals()

const props = withDefaults(defineProps<{
  title: string,
  message: string,
  confirmText?: string,
  cancelText?: string
}>(), {
  confirmText: 'Confirmar',
  cancelText: 'Fechar'
})

const emits = defineEmits<{
  onAction:[action: ConfirmModalResponse],
}>()

const handleAction = (action: ConfirmModalResponse) => {
  toggleModal(id)
  emits('onAction', action)
}

</script>
